<template>
  <b-badge
    pill
    class="state-badge"
    :class="statusClass"
  >
    {{ text }}
  </b-badge>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
    name: 'TranslatedEntityBadge',
    props: {
        value: { type: [String, Object], required: true },
        values: { type: Array, required: true },
        invalid: { type: Object, required: false }
    },
    data() {
        return {
            defaultInvalid: {
                id: 'INVALID',
                label: 'entities.incident.coreEntities.invalid',
                bgColor: 'red',
                color: 'white'
            }
        }
    },
    computed: {
        statusClass() {
            return this.optionValue.class
        },
        text() {
            return this.$_translateIfKeyExists(this.optionValue.name || this.optionValue.code || this.value)
        },
        optionValue() {
            const foundValue = cloneDeep(this.values.find((state) => (this.value.code || this.value) === (state.code || state.id)) || this.invalid || this.defaultInvalid)
            if (this.value.name) {
                foundValue.name = this.value.name
            }
            if (this.value.translatedName) {
                foundValue.name = this.value.translatedName
            }
            return foundValue
        }
    }
}
</script>

<style scoped lang="scss">
.sr-incident-badge {
  min-width: 85px;
}
</style>
